import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {SearchTitleBox} from "./boxes/search-title-box/search-title.box";
import {CyClass} from '../../../../../common/cy-classes';
import {Check} from "@sparkware/app-utils";
import {NumberOfResultsBox} from "./boxes/number-of-results-box/number-of-results.box";

export interface SearchBoxTitleComponentProps {
  title: string;
  numberOfResults?: number;
}

export class SearchBoxTitleComponent extends OrbitComponent<SearchBoxTitleComponentProps> {
  private _renderNumberOfResults = () => {
    if (Check.isNumber(this.props.numberOfResults)) {
      return <NumberOfResultsBox className={'cy-search-results-number'}>({this.props.numberOfResults})</NumberOfResultsBox>;
    }
    return null;
  }

  render() {
    return (
      <SearchTitleBox className={CyClass('cy-search-title-box')}>
        <span className={'cy-search-title-text'}>{this.services.translation.translate(this.props.title)}</span>
        {this._renderNumberOfResults()}
      </SearchTitleBox>
    )
  }
}
